'use client';
import { useState } from 'react';

import { Typography } from '@gds/Typography/Typography';
import { Scroller } from '@shared-components/Scroller/Scroller';

import { RichText } from '../RichText/RichText';

import { IntroCarouselItem } from './IntroCarousel.entity';

import styles from './IntroCarousel.module.css';

interface IntroCarouselProps {
  items: IntroCarouselItem[];
  messages: Record<string, string> | null;
}

export const IntroCarousel = ({ items, messages }: IntroCarouselProps) => {
  const [isOpened, setIsOpened] = useState(true);

  const toggleCarousel = () => {
    setIsOpened(prevState => !prevState);
  };

  return (
    <>
      <div className={styles.wrapper} data-is-opened={isOpened}>
        <div className={styles.title} onClick={toggleCarousel}>
          <Typography variant="h3" Component="h1">
            {messages?.howToBuy}
          </Typography>
          <div className={styles.toggle}>
            <Typography variant="buttonLink1">
              {isOpened ? messages?.viewLess : messages?.viewMore}
            </Typography>
          </div>
        </div>
        <Scroller scrollItemClass={styles.item} threshold={0.5} contained showDots>
          {items?.map(item => (
            <div className={styles.item} key={item.body}>
              <div className={styles.content}>
                <Typography variant="body1">
                  <RichText richText={item.body} />
                </Typography>
              </div>
            </div>
          ))}
        </Scroller>
      </div>
    </>
  );
};
